import axios from "axios";
import { runtimeConfig } from "../config/runtimeConfig";
import { buildAppPath } from "../config/appBasePath";

const withTrailingSlash = (value: string) => `${value.replace(/\/+$/, "")}/`;

export const API_URL = withTrailingSlash(runtimeConfig.apiUrl);

const TOKEN_KEY = "client_access_token";
const USER_KEY = "client_user_data";

function clearSessionAndRedirect() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    window.location.assign(buildAppPath("/login"));
}

/** Returns a fresh axios config with the current JWT token attached */
export function getBaseConfig() {
    const token = localStorage.getItem(TOKEN_KEY);
    return {
        timeout: 10000,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        validateStatus: (status: number) => status < 500,
    };
}

/**
 * Global axios response interceptor — catches 401 from any request
 * and redirects to login so the user gets a fresh token.
 */
axios.interceptors.response.use(
    (response) => {
        if (response.status === 401) {
            clearSessionAndRedirect();
        }
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            clearSessionAndRedirect();
        }
        return Promise.reject(error);
    }
);

export function handleError(error: any) {
    console.error("API error @ " + new Date(), error);
}

